import { Fragment, useState, useEffect, useCallback, useRef } from "react";
import "./topic_content_component.scss";
import { useLocation } from "react-router-dom";
import images from "../../../../../utilities/images/images";
import axios from "axios";
import { isEmpty } from "../../../../../custom_utilities/custom_useful_functions";
import {
  url_7,
  url_11,
  url_13,
  url_33,
  url_39,
  url_55,
  url_140,
  url_214,
  url_247,
  url_274,
} from "../../../../../custom_utilities/api_services";
import * as rdd from "react-device-detect";
import { connect } from "react-redux";
import uiActions from "../../../../../redux/ui/action";
import userActivityActions from "../../../../../redux/user_activity/action";
import userPyqTestsAction from "../../../../../redux/pyq_test_exercises/action";
import InfiniteScroll from "react-infinite-scroll-component";
import { setLiveVideoStreamDetails } from "../../../../../redux/live_video_streaming/LiveVideoStreamingSlice";
import {
  setWatchedVideoDetails,
  setNoteAddedVideoTime,
} from "../../../../../redux/watched_video_details/WatchedVideoDetailsSlice";
import { Lock } from "lucide-react";
import playIcon from "../topic_design_assets/play.svg";
import bookmarkIcon from "../topic_design_assets/bookmark.svg";
import bookmarkSavedIcon from "../topic_design_assets/bookmark-saved.svg";
import clockIcon from "../topic_design_assets/clock.svg";
import noteFileIcon from "../topic_design_assets/note-file.svg";
import noteChevronIcon from "../topic_design_assets/note-chevron.svg";
import { openLiveKitJoin } from "../../../livekit_component/livekit_utils";
import { clearExerciseProgress, clearSubmittedExercise, getPyqProgressType, hasTopicPracticeProgress, isResumePracticeExercise, isStartPracticeExercise } from "../../../evaluation_components/exercise_related_components/exercise_Test_component/exerciseTest_content_component/exercisePaperIdUtils";

const getFacultyInitials = (name = "") => {
  const parts = String(name)
    .trim()
    .split(/\s+/)
    .map((part) => part.replace(/[^A-Za-z]/g, ""))
    .filter(Boolean);

  if (!parts.length) return "";

  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return `${first}${last}`.toUpperCase();
};

const hasFacultyImage = (src) => {
  const thumbnail = typeof src === "string" ? src.trim() : "";
  if (!thumbnail) return false;
  const normalized = thumbnail.toLowerCase();
  return normalized !== "null" && normalized !== "undefined";
};

const FacultyAvatar = ({ name, src }) => {
  const thumbnail = hasFacultyImage(src) ? src.trim() : "";
  const [failedSrc, setFailedSrc] = useState("");
  const showImage = Boolean(thumbnail) && failedSrc !== thumbnail;

  if (!showImage) {
    return (
      <span className="faculty-initials" aria-hidden="true">
        {getFacultyInitials(name)}
      </span>
    );
  }

  return (
    <img src={thumbnail} alt="" onError={() => setFailedSrc(thumbnail)} />
  );
};

const TopicContentComponent = (props) => {
  let {
    history,
    userPreference,
    subjectData,
    topicData,
    startLoading,
    finishLoading,
    setVideoData,
    setRecordedVideoData,
    setNotesData,
    setLiveStreamData,
    setExerciseData,
    setLiveStreamVideoData,
    setLiveVideoStreamDetailsAction,
    setWatchedVideoDetailsAction,
    setNoteAddedVideoTimeAction,
    activeFeatureType,
    setActiveFeatureType,
    setPyqData,
    token,
    tokenType,
    setPyqTestsData,
    setPyqTopicSubject,
    userData,
    loader,
  } = props;

  let { courseDetails } = userPreference;
  const location = useLocation();

  const resolveCourseId = (locationState) => {
    if (locationState != null && typeof locationState !== "object") {
      return locationState;
    }

    if (locationState && typeof locationState === "object") {
      return (
        locationState.courseId ??
        locationState.course_id ??
        courseDetails?.[0]?.course_id
      );
    }

    return courseDetails?.[0]?.course_id;
  };

  const buildTopicReturnState = (extra = {}) => {
    const locationState = location.state;
    const base =
      locationState && typeof locationState === "object" ? locationState : {};

    return {
      ...base,
      courseId: resolveCourseId(locationState),
      fromSubject: false,
      ...extra,
    };
  };

  const persistTopicTab = (featureType) => {
    history.replace({
      pathname: location.pathname,
      state: buildTopicReturnState({
        featureType,
        fromSubject: false,
      }),
    });
  };

  let crsID = resolveCourseId(location.state);
  const fetchedSectionsRef = useRef(new Set());
  const facultyVideosCacheRef = useRef({});
  const videosPagingRef = useRef(false);
  const livePagingRef = useRef(false);
  const [videosHasMore, setVideosHasMore] = useState(true);
  const [videosLoading, setVideosLoading] = useState(true);
  const videosRequestRef = useRef(0);
  const [liveHasMore, setLiveHasMore] = useState(true);

  const initailFeatureTypeCheck = (topicData) => {
    const featureMapping = {
      is_video_available: 1,
      is_live_class_available: 2,
      is_excersice_available: 3,
      is_dpp_available: 4,
      is_notes_available: 5,
      is_additional_video_available: 6,
      topicId: 7,
    };

    for (const [key, value] of Object.entries(featureMapping)) {
      if (topicData[key]) {
        return value;
      }
    }
  };

  const incomingFeatureType = Number(location.state?.featureType);
  const openedFromSubject = Boolean(location.state?.fromSubject);
  const [state, setState] = useState({
    featureType: openedFromSubject
      ? 1
      : Number.isFinite(incomingFeatureType)
        ? incomingFeatureType
        : activeFeatureType || initailFeatureTypeCheck(topicData),
    videosData: [],
    additionalVideosData: [],
    facultyData: {},
    liveVideoData: [],
    liveClassesData: {},
    exercisesData: {},
    notesData: [],
    pageNumber: 1,
    recordedPageNumber: 1,
    currentFacultyName: {},
    additionalFacultyData: {},
    additionalCurrentFacultyName: {},
  });

  useEffect(() => {
    if (activeFeatureType && activeFeatureType !== state.featureType) {
      setState((prevState) => ({
        ...prevState,
        featureType: activeFeatureType,
      }));
    }
  }, [activeFeatureType]);

  useEffect(() => {
    if (location.state?.fromSubject) {
      setActiveFeatureType(1);
      setState((prevState) => ({
        ...prevState,
        featureType: 1,
      }));
      return;
    }
    const incomingFeature = location.state?.featureType;
    if (incomingFeature == null || incomingFeature === "") return;
    const featureNum = Number(incomingFeature);
    if (!Number.isFinite(featureNum)) return;
    setActiveFeatureType(featureNum);
    setState((prevState) => ({
      ...prevState,
      featureType: featureNum,
    }));
  }, [
    location.state?.featureType,
    location.state?.fromSubject,
    setActiveFeatureType,
  ]);

  const getVideosData = useCallback(async () => {
    let data = {
      search: "",
      course_id: crsID,
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
      faculty_id: state?.currentFacultyName?.user_id,
    };
    const facultyId = data.faculty_id;
    const requestId = ++videosRequestRef.current;
    setVideosLoading(true);
    try {
      const response = await axios.get(
        `${url_11}?page=1&search=${data.search}&course_id=${data.course_id}&subject_id=${data.subject_id}&topic_id=${data.topic_id}&faculty_id=${data.faculty_id}`
      );
      if (requestId !== videosRequestRef.current) return;
      if (response.data.status === 200) {
        const videoPage = response.data.data.VideoList.data || [];
        facultyVideosCacheRef.current[facultyId] = {
          videos: videoPage,
          hasMore: videoPage.length >= 10,
        };
        setVideosHasMore(videoPage.length >= 10);
        setState((prevState) => {
          if (
            String(prevState.currentFacultyName?.user_id) !== String(facultyId)
          ) {
            return prevState;
          }
          return {
            ...prevState,
            videosData: [...videoPage],
          };
        });
      }
    } catch (error) {
      if (requestId !== videosRequestRef.current) return;
      console.log(error);
    } finally {
      if (requestId === videosRequestRef.current) {
        setVideosLoading(false);
      }
    }
  }, [
    crsID,
    state?.currentFacultyName?.user_id,
    subjectData?.subjectId,
    topicData.topicId,
  ]);

  const getPyqData = useCallback(async () => {
    let data = {
      search: "",
      course_id: crsID,
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
    };
    startLoading();
    try {
      const response = await axios.get(
        `https://learning.motion.ac.in/motioneducation/api/v1/pyq_topicwise_list?topic_id=${data.topic_id}&subject_id=${data.subject_id}`,
        {
          headers: {
            Authorization: `${tokenType} ${token}`,
          },
        }
      );
      if (response.data.status === 200) {
        finishLoading();
        setPyqData(response.data.data);
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  }, [
    finishLoading,
    startLoading,
    subjectData?.subjectId,
    topicData.topicId,
    token,
    tokenType,
    setPyqData,
  ]);

  const getRecordedLiveClassData = useCallback(
    async (page = 1) => {
      let data = {
        subject_id: subjectData?.subjectId,
        topic_id: topicData.topicId,
        type: "live",
        page: page,
      };
      startLoading();
      try {
        const response = await axios.get(
          `${url_214}/?subject_id=${data.subject_id}&topic_id=${data.topic_id}&type=live&page=${data.page}`
        );
        if (response.status === 200) {
          const livePage = response.data.data || [];
          setLiveHasMore(livePage.length >= 10);
          setState((prevState) => ({
            ...prevState,
            liveVideoData: [...livePage],
          }));
          finishLoading();
        } else {
          alert(response.data.message);
          finishLoading();
        }
      } catch (error) {
        finishLoading();
        console.log(error);
      }
    },
    [startLoading, finishLoading, subjectData?.subjectId, topicData.topicId]
  );

  const getFacultyData = useCallback(async () => {
    let data = {
      search: "",
      course_id: crsID,
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
    };
    try {
      const response = await axios.get(
        `${url_140}?page=1&search=${data.search}&course_id=${data.course_id}&subject_id=${data.subject_id}&topic_id=${data.topic_id}`
      );

      if (response.data.status === 200) {
        const facultyList = response.data.data.VideoList || [];
        let savedFacultyId = location.state?.facultyId;
        if (savedFacultyId == null && topicData.topicId != null) {
          try {
            savedFacultyId = sessionStorage.getItem(
              `topicSelectedFaculty:${topicData.topicId}`
            );
          } catch (error) {
            savedFacultyId = null;
          }
        }
        setState((prevState) => {
          const preferredId =
            prevState.currentFacultyName?.user_id || savedFacultyId;
          const matchedFaculty = facultyList.find(
            (faculty) => String(faculty.user_id) === String(preferredId)
          );
          return {
            ...prevState,
            facultyData: response.data.data,
            currentFacultyName: matchedFaculty || facultyList[0] || {},
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [crsID, subjectData?.subjectId, topicData.topicId]);

  const getAdditionalFacultyData = useCallback(async () => {
    let data = {
      search: "",
      course_id: crsID,
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
      type: 2,
    };
    try {
      const response = await axios.get(
        `${url_140}?page=1&search=${data.search}&course_id=${data.course_id}&subject_id=${data.subject_id}&topic_id=${data.topic_id}&type=${data.type}`
      );

      if (response.data.status === 200) {
        setState((prevState) => ({
          ...prevState,
          additionalFacultyData: response.data.data,
          additionalCurrentFacultyName: response.data.data.VideoList[0],
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }, [crsID, subjectData?.subjectId, topicData.topicId]);

  const getAdditionalVideosData = useCallback(async () => {
    let data = {
      search: "",
      type: 2,
      course_id: crsID,
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
      faculty_id: state?.additionalCurrentFacultyName?.user_id,
    };
    startLoading();
    try {
      const response = await axios.get(
        `${url_11}?page=1&search=${data.search}&course_id=${data.course_id}&subject_id=${data.subject_id}&topic_id=${data.topic_id}&faculty_id=${data.faculty_id}&type=${data.type}`
      );
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          additionalVideosData: [...response.data.data.VideoList.data],
        }));
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  }, [
    crsID,
    finishLoading,
    startLoading,
    state?.additionalCurrentFacultyName?.user_id,
    subjectData?.subjectId,
    topicData.topicId,
  ]);

  const getExerciseList = useCallback(async () => {
    let requestPayload = {
      course_id: crsID,
      topic_id: topicData.topicId,
      page: 0,
      type: "Exercise",
    };
    startLoading();
    try {
      const response = await axios.post(url_33, requestPayload);
      if (response.data.status === 200) {
        setState((prevState) => ({
          ...prevState,
          exercisesData: response.data.data,
        }));
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  }, [crsID, finishLoading, startLoading, topicData.topicId]);

  const getNotesData = useCallback(async () => {
    let data = {
      search: "",
      course_id: crsID,
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
    };

    startLoading();
    try {
      const response = await axios.get(
        `${url_13}?page=1&search=${data.search}&course_id=${data.course_id}&subject_id=${data.subject_id}&topic_id=${data.topic_id}`
      );

      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          notesData: [...response.data.data.NotesList.data],
        }));
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  }, [
    crsID,
    finishLoading,
    startLoading,
    subjectData?.subjectId,
    topicData.topicId,
  ]);

  const getDppList = useCallback(async () => {
    let data = {
      course_id: crsID,
      type: "DPP",
      topic_id: topicData.topicId,
      page: 0,
    };

    startLoading();
    try {
      const response = await axios.post(url_33, data);
      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          dppCollections: response.data.data,
        }));
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  }, [crsID, finishLoading, startLoading, topicData.topicId]);

  const getInitialRenderData = useCallback(() => {
    const section = state.featureType;
    if (!section) return;

    const sectionKey = `${topicData?.topicId ?? ""}:${crsID ?? ""}:${
      subjectData?.subjectId ?? ""
    }:${section}`;
    if (fetchedSectionsRef.current.has(sectionKey)) return;
    fetchedSectionsRef.current.add(sectionKey);

    switch (section) {
      case 1:
        getFacultyData();
        break;
      case 2:
        getRecordedLiveClassData();
        break;
      case 3:
        getExerciseList();
        break;
      case 4:
        getNotesData();
        break;
      case 5:
        getDppList();
        break;
      case 6:
        getAdditionalFacultyData();
        break;
      case 7:
        getPyqData();
        break;
      default:
        break;
    }
  }, [
    crsID,
    getAdditionalFacultyData,
    getDppList,
    getExerciseList,
    getFacultyData,
    getNotesData,
    getRecordedLiveClassData,
    getPyqData,
    state.featureType,
    subjectData?.subjectId,
    topicData?.topicId,
  ]);

  useEffect(() => {
    getInitialRenderData();
  }, [getInitialRenderData]);

  useEffect(() => {
    if (state.featureType !== 1 || !state.currentFacultyName?.user_id) {
      return;
    }
    const facultyId = state.currentFacultyName.user_id;
    const cachedVideos = facultyVideosCacheRef.current[facultyId];
    if (cachedVideos) {
      videosRequestRef.current += 1;
      setVideosLoading(false);
      setVideosHasMore(cachedVideos.hasMore !== false);
      setState((prevState) => {
        if (prevState.videosData === cachedVideos.videos) return prevState;
        return {
          ...prevState,
          videosData: cachedVideos.videos,
        };
      });
      return;
    }
    const videoKey = `videos:${topicData?.topicId ?? ""}:${facultyId}`;
    if (fetchedSectionsRef.current.has(videoKey)) return;
    fetchedSectionsRef.current.add(videoKey);
    getVideosData();
  }, [
    state.featureType,
    state.currentFacultyName?.user_id,
    getVideosData,
    topicData?.topicId,
  ]);

  useEffect(() => {
    if (
      state.featureType !== 6 ||
      !state.additionalCurrentFacultyName?.user_id
    ) {
      return;
    }
    const videoKey = `additional-videos:${topicData?.topicId ?? ""}:${
      state.additionalCurrentFacultyName.user_id
    }`;
    if (fetchedSectionsRef.current.has(videoKey)) return;
    fetchedSectionsRef.current.add(videoKey);
    getAdditionalVideosData();
  }, [
    state.featureType,
    state.additionalCurrentFacultyName?.user_id,
    getAdditionalVideosData,
    topicData?.topicId,
  ]);

  useEffect(() => {
    return () => {
      finishLoading();
    };
  }, [finishLoading]);

  const handleChangeFaculty = (element) => {
    if (topicData?.topicId != null && element?.user_id != null) {
      try {
        sessionStorage.setItem(
          `topicSelectedFaculty:${topicData.topicId}`,
          String(element.user_id)
        );
      } catch (error) {
        // Keep the in-page selection even if storage is unavailable.
      }
    }
    const cachedVideos = facultyVideosCacheRef.current[element?.user_id];
    if (cachedVideos) {
      videosRequestRef.current += 1;
      setVideosLoading(false);
    } else {
      setVideosLoading(true);
    }
    setVideosHasMore(cachedVideos ? cachedVideos.hasMore !== false : true);
    setState((prevState) => ({
      ...prevState,
      currentFacultyName: element,
      videosData: cachedVideos ? cachedVideos.videos : [],
    }));
    history.replace({
      pathname: location.pathname,
      state: buildTopicReturnState({
        featureType: state.featureType,
        facultyId: element?.user_id,
        fromSubject: false,
      }),
    });
    finishLoading();
  };

  const renderFetaures = () => {
    let featureType = state.featureType;
    switch (featureType) {
      case 1:
        return renderVideosCollectionView();
      case 2:
        return renderLiveClassCollectionView();
      case 3:
        return renderExerciseCollectionView();
      case 4:
        return renderNotesCollectionView();
      case 5:
        return renderDppCollectionView();
      case 6:
        return renderAdditionalVideosCollectionView();
      case 7:
        return renderPyqCollectionView();
      default:
        return null;
    }
  };

  const decrypt_functionality = (val) => {
    const CryptoJS = require("crypto-js");
    let encrypted = val;
    let key = "0CiuKpLCZbX7gBCyYTka4USxTnh7ssXKk8bJ6Y3TXPc=";
    encrypted = atob(encrypted);
    encrypted = JSON.parse(encrypted);
    const iv = CryptoJS.enc.Base64.parse(encrypted.iv);
    const value = encrypted.value;
    key = CryptoJS.enc.Base64.parse(key);
    var decrypted = CryptoJS.AES.decrypt(value, key, { iv: iv });
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);
    return decrypted.split("*")[1];
  };

  const setLiveClassRecord = async (element) => {
    if (String(element.stream_service) === "3") {
      const meetingId = element?.id || element?.zoom_id || "unknown";
      const userId = userData?.user_id || "";
      openLiveKitJoin(meetingId, userId);
      return;
    }

    let zoomId = decrypt_functionality(element.zoom_id);
    let data = {
      device_id: rdd.fullBrowserVersion,
      device_type: rdd.browserName,
      device_name: rdd.osName,
      zoom_id: zoomId,
      type: "Web",
    };
    startLoading();
    try {
      const response = await axios.post(url_55, data);
      if (response.data.status === 200) {
        finishLoading();
        const streamPayload = {
          ...response.data.data,
          ...element,
          redirectedFrom: "activity",
        };
        setLiveStreamData(streamPayload);
        history.push("/zoom");
      } else {
        finishLoading();
        alert(response.data.message);
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  };

  const isStreamOsRecordingId = (id) => /^rec-/i.test(String(id || "").trim());

  const openRecordedStream = (playbackId, element) => {
    setLiveVideoStreamDetailsAction({
      zoomId: playbackId,
      isLive: false,
      live_class_id: "",
      normalVideos: false,
    });

    setRecordedVideoData(element);
    setVideoData(element);

    history.push({
      pathname: "/streaming",
      state: {
        zoomId: playbackId,
        isLive: false,
        videoId: element?.video_id,
        returnToTopic: buildTopicReturnState({
          screenVersion: "new",
          featureType: 2,
          tab: "live_class",
        }),
      },
    });
  };

  const openRecordedDrm = (element) => {
    const playback = {
      ...element,
      redirectedFrom: "activity",
      vod_type: 1,
    };

    setRecordedVideoData(playback);
    setVideoData(playback);
    setWatchedVideoDetailsAction(playback);
    setNoteAddedVideoTimeAction(0);
    setLiveVideoStreamDetailsAction({
      zoomId: playback.video_crypt_id,
      isLive: false,
      live_class_id: "",
      normalVideos: false,
    });
    history.push({
      pathname: "/streaming",
      state: {
        zoomId: playback.video_crypt_id,
        isLive: false,
        videoId: playback.video_id,
        vodType: 1,
        videoCryptId: playback.video_crypt_id,
        title:
          playback.meeting_topic ||
          playback.video_title ||
          playback.video_description,
        returnToTopic: buildTopicReturnState({
          screenVersion: "new",
          featureType: 2,
          tab: "live_class",
        }),
      },
    });
  };

  const handleRecordedWatchNow = async (element) => {
    const streamService = String(element?.stream_service ?? "");
    const listedId = element?.zoom_id || element?.video_crypt_id || "";

    // Stream service 2 already stores a StreamOS recording id (`rec-...`).
    if (
      (streamService === "2" || isStreamOsRecordingId(listedId)) &&
      Number(element?.vod_type) !== 1
    ) {
      setLiveVideoStreamDetailsAction({
        zoomId: element?.zoom_id || element?.video_crypt_id,
        isLive: false,
        live_class_id: "",
        normalVideos: false,
      });

      history.push({
        pathname: "/streaming",
        state: {
          zoomId: element?.zoom_id || element?.video_crypt_id,
          isLive: false,
          videoId: element?.video_id,
          returnToTopic: buildTopicReturnState({
            screenVersion: "new",
            featureType: 2,
            tab: "live_class",
          }),
        },
      });

      setRecordedVideoData(element);
      setVideoData(element);
      return;
    }

    let detail = null;
    if (element?.video_id) {
      startLoading();
      try {
        const response = await axios.get(
          `${url_7}?video_id=${element.video_id}`
        );
        if (response?.data?.status === 200) {
          detail = response.data.data?.VideoDetail || null;
        }
      } catch (error) {
        console.log(error);
      } finally {
        finishLoading();
      }
    }

    const vodType = Number(detail?.vod_type ?? element?.vod_type);
    const cryptId = detail?.video_crypt_id || element?.video_crypt_id;
    const playback = detail
      ? {
          ...element,
          ...detail,
          stream_service: element.stream_service,
          zoom_id: element.zoom_id,
          video_crypt_id: cryptId,
          vod_type: detail.vod_type,
        }
      : element;

    // vod_type 2 plays on StreamOS with the crypt id. vod_type 1 plays in the
    // DRM player. Stream service 1 lists a Zoom recording id, which StreamOS
    // rejects with "Stream Os Down".
    if (vodType === 2 && cryptId) {
      openRecordedStream(cryptId, playback);
      return;
    }

    if (cryptId) {
      openRecordedDrm({ ...playback, vod_type: 1, video_crypt_id: cryptId });
      return;
    }

    openRecordedStream(listedId, element);
  };

  const handleStoreDataInStorage = (type, data) => {
    persistTopicTab(state.featureType);
    if (type === "exercise") {
      const exerciseContext = {
        userId: userData?.user_id,
        courseId: courseDetails?.[0]?.course_id,
        topicId: topicData?.topicId,
        exerciseType: data.excersie_type,
      };
      const shouldStartFresh = isStartPracticeExercise(data, {
        userId: exerciseContext.userId,
        courseId: exerciseContext.courseId,
        topicId: exerciseContext.topicId,
      });

      if (shouldStartFresh) {
        clearExerciseProgress(exerciseContext);
        clearSubmittedExercise(exerciseContext);
        data.redirectedFrom = "activity";
        data.exerciseType = "Exercise";
        setExerciseData(data);
        history.push({
          pathname: "/topic_component/exercise-instruction",
          exact: true,
          state: {
            type: "exercise",
            isResume: false,
            topicData: topicData,
            subjectData: subjectData,
            returnState: buildTopicReturnState({
              tab: "exercise",
              featureType: 3,
            }),
          },
        });
      } else {
        data.redirectedFrom = "activity";
        data.exerciseType = "Exercise";
        setExerciseData(data);
        history.push({
          pathname: "/topic_component/exercise-instruction",
          exact: true,
          state: {
            type: "exercise",
            isResume: true,
            topicData: topicData,
            subjectData: subjectData,
            returnState: buildTopicReturnState({
              tab: "exercise",
              featureType: 3,
            }),
          },
        });
      }
    } else if (type === "dpp") {
      const dppInProgress = hasTopicPracticeProgress({
        userId: userData?.user_id,
        courseId: courseDetails?.[0]?.course_id,
        topicId: topicData?.topicId,
        exerciseType: data.excersie_type,
      });
      data.redirectedFrom = "activity";
      data.exerciseType = "Dpp";
      setExerciseData(data);
      history.push({
        pathname: "/topic_component/dpp-instruction",
        exact: true,
        state: {
          type: "dpp",
          isResume: dppInProgress,
          topicData: topicData,
          subjectData: subjectData,
          returnState: buildTopicReturnState({
            tab: "dpp",
            featureType: 5,
          }),
        },
      });
    } else {
      if (data.is_paid === 0) {
        switch (type) {
          case "videos":
            data.redirectedFrom = "activity";
            setLiveVideoStreamDetailsAction({
              zoomId: data?.zoom_id || data?.video_crypt_id,
              isLive: false,
              live_class_id: "",
              normalVideos: true,
            });

            setVideoData(data);
            setWatchedVideoDetailsAction(data);
            setNoteAddedVideoTimeAction(0);
            history.push({
              pathname: "/videos",
              state: buildTopicReturnState({
                tab: "videos",
                featureType: 1,
                facultyId: state.currentFacultyName?.user_id,
              }),
            });
            break;
          case "live_class":
            setLiveClassRecord(data);
            break;
          case "live_class_video":
            data.redirectedFrom = "activity";
            setLiveStreamVideoData(data);
            history.push({
              pathname: "/live_stream_video",
              state: buildTopicReturnState({
                tab: "live_class",
                featureType: 2,
              }),
            });
            break;
          case "exercise":
            break;
          case "notes":
            data.redirectedFrom = "activity";
            setNotesData(data);
            history.push({
              pathname: "/notes",
              state: buildTopicReturnState({
                tab: "notes",
                featureType: 4,
              }),
            });
            break;
          default:
            break;
        }
      } else if (type === "pyq") {
        const returnState = buildTopicReturnState({
          tab: "pyq",
          featureType: 7,
        });
        const newData = {
          ...data,
          redirectedFrom: "activity",
          topic_id: data?.topic_id ?? topicData?.topicId ?? null,
          topic_name: data?.topic_name ?? topicData?.topicName ?? "",
          format: data?.format ?? null,
          subject:
            data?.subject ??
            subjectData?.subjectName ??
            subjectData?.sub_name ??
            null,
          subject_id:
            data?.subject_id ??
            subjectData?.subjectId ??
            subjectData?.sub_id ??
            null,
          returnTo: "/topic_component",
          returnState,
        };
        setPyqTopicSubject({
          subId: newData.subject_id,
          subName: newData.subject,
        });
        const pyqInProgress = hasTopicPracticeProgress({
          userId: userData?.user_id,
          courseId: courseDetails?.[0]?.course_id,
          topicId: topicData?.topicId,
          exerciseType: getPyqProgressType(newData),
        });
        setPyqTestsData(newData);
        history.push({
          pathname: "/topic_component/pyq-instruction",
          state: {
            type: "pyq",
            isResume: pyqInProgress,
            returnTo: "/topic_component",
            returnState,
            tab: "pyq",
          },
        });
      } else {
        alert("Please purchase subscription");
        history.push("/store");
      }
    }
  };

  const handleBookmarkVideo = async (videoDetails) => {
    let videoList = [...state.videosData];

    let videoIndex = videoList.findIndex(
      (element) => element.video_id === videoDetails.video_id
    );

    if (videoIndex !== -1) {
      videoList[videoIndex].IsSaved = !videoList[videoIndex].IsSaved;

      setState((prevState) => ({
        ...prevState,
        videosData: videoList,
      }));
    } else {
      return;
    }

    let data = {
      type: 4,
      reference_id: videoDetails.video_id,
      status: videoList[videoIndex].IsSaved ? 1 : 0,
    };

    try {
      await axios.post(url_39, data);
    } catch (error) {
      console.log(error);
    }
  };

  const renderVideosCollectionView = () => {
    const allVideosLocked = state.videosData.every(
      (video) => video.is_locked === 1
    );

    return (
      <Fragment>
        <div className="videosCollectionView_wrapper">
          <div className="videosCollectionView_inner_wrapper">
            <div className="sec_2_wrapper">
              <div className="faculty_tabs">
                {!isEmpty(state.facultyData) &&
                state.facultyData.VideoList.length
                  ? state.facultyData.VideoList.map((element, index) => (
                      <div key={index} className="single_select_facultyName">
                        <input
                          type="radio"
                          id={`facultyName_${element.name}`}
                          name="facultyName"
                          value={element.name}
                          checked={
                            state.currentFacultyName.name === element.name
                          }
                          onChange={() => handleChangeFaculty(element)}
                        />
                        <label htmlFor={`facultyName_${element.name}`}>
                          <span>
                            <FacultyAvatar
                              name={element.name}
                              src={element.thumnail}
                            />
                          </span>
                          {element.name}
                        </label>
                      </div>
                    ))
                  : null}
              </div>
              <div className="sec_2_inner_wrapper">
                {videosLoading ? (
                  <div className="videos_collection_wrapper" aria-hidden="true">
                    {[0, 1, 2, 3, 4, 5].map((item) => (
                      <div
                        key={item}
                        className="topic-lecture-card topic-lecture-skeleton"
                      >
                        <div className="topic-skeleton-photo" />
                        <div className="topic-skeleton-lines">
                          <div className="topic-skeleton-line topic-skeleton-line--title" />
                          <div className="topic-skeleton-line" />
                          <div className="topic-skeleton-line topic-skeleton-line--short" />
                        </div>
                        <div className="topic-skeleton-button" />
                      </div>
                    ))}
                  </div>
                ) : state.videosData.length ? (
                  <div
                    id="parentScrollDiv"
                    className="videosListBox topic-videos-scroll"
                  >
                      <InfiniteScroll
                      dataLength={state.videosData.length}
                      next={fetchData}
                      hasMore={videosHasMore && !allVideosLocked}
                      loader={<span className="topic-scroll-spacer" />}
                      scrollableTarget="parentScrollDiv"
                    >
                      <div className="videos_collection_wrapper">
                        {state.videosData.map((element, index) => {
                          const isLocked = element.is_locked === 1;
                          const lectureDuration =
                            element.video_duration ||
                            element.duration ||
                            element.video_time ||
                            "";
                          const openVideo = () =>
                            isLocked
                              ? history.push("/store")
                              : handleStoreDataInStorage("videos", element);

                          return (
                            <div key={index} className="single_video_wrapper topic-lecture-card">
                              {isLocked && (
                                <div
                                  className="lock_overlay"
                                  onClick={() => history.push("/store")}
                                >
                                  <Lock
                                    size={48}
                                    color="#ffffff"
                                    aria-label="Locked video"
                                  />
                                </div>
                              )}
                              <div
                                className="topic-lecture-main"
                                onClick={openVideo}
                              >
                                <div className="topic-lecture-photo">
                                  <img src={element.thumnail} alt="" />
                                </div>
                                <div className="topic-lecture-info">
                                  <p className="text_content_1">
                                    {element.video_title}
                                  </p>
                                  <p className="text_content_2">
                                    by {element.name}
                                  </p>
                                  {lectureDuration ? (
                                    <div className="topic-lecture-meta">
                                      <img src={clockIcon} alt="" />
                                      <span>{lectureDuration}</span>
                                    </div>
                                  ) : null}
                                  {element.video_rating ? (
                                    <div className="topic-lecture-meta">
                                      <img
                                        src={images.user_activity_2}
                                        alt=""
                                      />
                                      <span>{element.video_rating}</span>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="topic-lecture-actions">
                                <button
                                  type="button"
                                  className="topic-bookmark-btn"
                                  onClick={() =>
                                    !isLocked && handleBookmarkVideo(element)
                                  }
                                >
                                  <img
                                    src={
                                      element.IsSaved
                                        ? bookmarkSavedIcon
                                        : bookmarkIcon
                                    }
                                    alt={
                                      element.IsSaved
                                        ? "Bookmarked"
                                        : "Not Bookmarked"
                                    }
                                  />
                                </button>
                                <button
                                  type="button"
                                  className="topic-watch-btn"
                                  onClick={openVideo}
                                  disabled={isLocked}
                                >
                                  <img src={playIcon} alt="" />
                                  {isLocked ? "Locked" : "Watch video"}
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </InfiniteScroll>
                  </div>
                ) : (
                  <div
                    className="no_data_found_wrapper"
                    style={{ textAlign: "center", margin: "auto" }}
                  >
                    <img src={images.new_m2_video_ntF} alt="No Videos" />
                    <p>There is no video yet!</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderAdditionalVideosCollectionView = () => {
    return (
      <Fragment>
        <div className="videosCollectionView_wrapper">
          <div className="videosCollectionView_inner_wrapper">
            <div className="sec_2_wrapper">
              <div className="faculty_tabs">
                {!isEmpty(state.additionalFacultyData) &&
                state.additionalFacultyData.VideoList.length ? (
                  state.additionalFacultyData.VideoList.map(
                    (element, index) => {
                      return state.additionalFacultyData.VideoList.length >
                        1 ? (
                        <div key={index} className="single_select_facultyName">
                          <input
                            type="radio"
                            id={`facultyName_${element.name}`}
                            name="facultyName"
                            value={element.name}
                            checked={
                              state.currentFacultyName.name === element.name
                            }
                            onChange={() => handleChangeFaculty(element)}
                          />
                          <label htmlFor={`facultyName_${element.name}`}>
                            <span>
                              <FacultyAvatar
                                name={element.name}
                                src={element.thumnail}
                              />
                            </span>
                            {element.name}
                          </label>
                        </div>
                      ) : null;
                    }
                  )
                ) : (
                  <div
                    className="no_data_found_wrapper"
                    style={{ textAlign: "center", margin: "auto" }}
                  >
                    <img src={images.new_m2_video_ntF} alt="No Videos" />
                    <p>There is no video yet!</p>
                  </div>
                )}
              </div>

              <div className="sec_2_inner_wrapper">
                {state.additionalVideosData.length ? (
                  <div
                    id="parentScrollDiv"
                    className="videosListBox"
                    style={{
                      height: "56vh",
                      overflow: "auto",
                      overflowY: "scroll",
                    }}
                  >
                    <InfiniteScroll
                      dataLength={state.additionalVideosData.length}
                      next={fetchData}
                      hasMore={true}
                      scrollableTarget="parentScrollDiv"
                    >
                      <div className="videos_collection_wrapper">
                        {state.additionalVideosData.length ? (
                          state.additionalVideosData.map((element, index) => (
                            <div key={index} className="single_video_wrapper topic-lecture-card">
                              <div
                                className="topic-lecture-main"
                                onClick={() =>
                                  handleStoreDataInStorage("videos", element)
                                }
                              >
                                <div className="topic-lecture-photo">
                                  <img src={element.thumnail} alt="" />
                                </div>
                                <div className="topic-lecture-info">
                                  <p className="text_content_1">
                                    {element.video_title}
                                  </p>
                                  <p className="text_content_2">
                                    by {element.name}
                                  </p>
                                </div>
                              </div>
                              <div className="topic-lecture-actions">
                                <button
                                  type="button"
                                  className="topic-watch-btn"
                                  onClick={() =>
                                    handleStoreDataInStorage("videos", element)
                                  }
                                >
                                  <img src={playIcon} alt="" />
                                  Watch video
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div
                            className="no_data_found_wrapper"
                            style={{ textAlign: "center", margin: "auto" }}
                          >
                            <img
                              src={images.new_m2_video_ntF}
                              alt="ntf-image"
                            />
                            <p>There is no video yet!</p>
                          </div>
                        )}
                      </div>
                    </InfiniteScroll>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderLiveClassCollectionView = () => {
    return (
      <Fragment>
        <div className="liveClassCollectionView_wrapper">
          <div className="liveClassCollectionView_inner_wrapper">
            <div className="section_wrapper">
              <div className="section_inner_wrapper">
                <div className="tab_wrapper">
                  <div
                    className="tab-content custom_tab_content"
                    id="pills-tabContent"
                  >
                    <div
                      className="tab-pane fade show active custom_tab_pane"
                      id="pills-previous-class"
                      role="tabpanel"
                      aria-labelledby="pills-previous-class-tab"
                    >
                      <div className="previous_class_tab_wrapper">
                        <div
                          className="outer_content_wrapper"
                          id="parentScrollDiv"
                          style={{
                            height: "calc(100vh - 320px)",
                            overflow: "auto",
                            padding: "4px 4px 24px",
                          }}
                        >
                          {!isEmpty(state?.liveVideoData) ? (
                            <InfiniteScroll
                              dataLength={state?.liveVideoData?.length}
                              next={fetchLiveRecordedData}
                              hasMore={liveHasMore}
                              loader={<span className="topic-scroll-spacer" />}
                              scrollableTarget="parentScrollDiv"
                            >
                              <div className="liveClasses_collection_wrapper videos_collection_wrapper">
                                {state.liveVideoData?.map((element, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="topic-lecture-card"
                                    >
                                      <div
                                        className="topic-lecture-main"
                                        onClick={() =>
                                          handleRecordedWatchNow(element)
                                        }
                                      >
                                        <div className="topic-lecture-photo">
                                          <img
                                            src={
                                              element.faculty_image ||
                                              images.play_thumbnail_image
                                            }
                                            alt=""
                                          />
                                        </div>
                                        <div className="topic-lecture-info">
                                          <p className="text_content_1">
                                            {element.meeting_topic}
                                          </p>
                                          <p className="text_content_2">
                                            by {element.faculty}
                                          </p>
                                          {element.meetdate ? (
                                            <div className="topic-lecture-meta">
                                              <span>{element.meetdate}</span>
                                            </div>
                                          ) : null}
                                          {element.meeting_duration ? (
                                            <div className="topic-lecture-meta">
                                              <img src={clockIcon} alt="" />
                                              <span>
                                                {element.meeting_duration}
                                              </span>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                      <div className="topic-lecture-actions">
                                        <button
                                          type="button"
                                          className="topic-watch-btn"
                                          onClick={() =>
                                            handleRecordedWatchNow(element)
                                          }
                                        >
                                          <img src={playIcon} alt="" />
                                          Watch video
                                        </button>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </InfiniteScroll>
                          ) : (
                            <div
                              className="no_data_found_wrapper"
                              style={{ textAlign: "center", margin: "auto" }}
                            >
                              <img
                                src={images.new_m2_video_ntF}
                                alt="ntf-image"
                              />
                              <p>No Recorded class is available as of now</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const getPracticeDurationMins = (item) =>
    item?.duration_mins ??
    item?.duration ??
    item?.time_duration ??
    item?.paper_duration ??
    item?.max_time;

  const renderPracticeDocCard = ({
    cardKey,
    title,
    questionCount,
    durationMins,
    isResume,
    onClick,
  }) => {
    const count = Number(questionCount) || 0;
    const duration = Number(durationMins);
    const meta =
      Number.isFinite(duration) && duration > 0
        ? `${count} Questions • Max ${duration} mins`
        : `${count} Questions`;

    return (
      <div key={cardKey} className="topic-practice-card" onClick={onClick}>
        <div className="topic-practice-card__main">
          <div className="topic-practice-card__icon">
            <img src={noteFileIcon} alt="" />
          </div>
          <div className="topic-practice-card__copy">
            <p className="topic-practice-card__title">{title}</p>
            <p className="topic-practice-card__meta">{meta}</p>
          </div>
        </div>
        <button
          type="button"
          className={`topic-practice-card__action${
            isResume ? " is-resume" : ""
          }`}
          onClick={(event) => {
            event.stopPropagation();
            onClick();
          }}
        >
          {isResume ? "Resume" : "Practice"}
        </button>
      </div>
    );
  };

  const renderExerciseCollectionView = () => {
    const exerciseListContext = {
      userId: userData?.user_id,
      courseId: courseDetails?.[0]?.course_id,
      topicId: topicData?.topicId,
    };
    const startPracticeExercises =
      state.exercisesData?.ExerciseList?.filter((exercise) =>
        isStartPracticeExercise(exercise, exerciseListContext)
      ) || [];
    const resumePracticeExercises =
      state.exercisesData?.ExerciseList?.filter((exercise) =>
        isResumePracticeExercise(exercise, exerciseListContext)
      ) || [];

    return (
      <Fragment>
        <div className="exerciseCollectionView_wrapper">
          <div className="exerciseCollectionView_inner_wrapper">
            <div className="sec_1_wrapper">
              <div className="options_wrapper">
                <ul
                  className="nav nav-pills custom_nav_pills"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item custom_nav_item" role="presentation">
                    <button
                      className="nav-link active custom_nav_link"
                      id="pills-upcoming-class-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-upcoming-class"
                      type="button"
                      role="tab"
                      aria-controls="pills-upcoming-class"
                      aria-selected="true"
                    >
                      Start Practice
                    </button>
                  </li>
                  <li className="nav-item custom_nav_item" role="presentation">
                    <button
                      className="nav-link custom_nav_link"
                      id="pills-previous-class-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-previous-class"
                      type="button"
                      role="tab"
                      aria-controls="pills-previous-class"
                      aria-selected="false"
                    >
                      Resume Practice
                    </button>
                  </li>
                </ul>
              </div>
              <div
                className="tab-content custom_tab_content"
                id="pills-tabContent"
              >
                <div
                  className="tab-pane fade show active custom_tab_pane"
                  id="pills-upcoming-class"
                  role="tabpanel"
                  aria-labelledby="pills-upcoming-class-tab"
                >
                  <div className="sec_1_inner_wrapper">
                    <div
                      className="exercise_collection_wrapper"
                      style={{
                        overflowY: "visible",
                        padding: "0",
                      }}
                    >
                      {!isEmpty(state.exercisesData) ? (
                        state.exercisesData.ExerciseList.length ? (
                          startPracticeExercises.length ? (
                            startPracticeExercises.map((element, index) =>
                              renderPracticeDocCard({
                                cardKey: `non-attempted-${index}`,
                                title: element.excersie_type,
                                questionCount: element.total_question,
                                durationMins: getPracticeDurationMins(element),
                                isResume: false,
                                onClick: () =>
                                  handleStoreDataInStorage("exercise", element),
                              })
                            )
                          ) : (
                            <div
                              className="no_data_found_wrapper"
                              style={{ textAlign: "center", margin: "auto" }}
                            >
                              <img
                                src={images.new_m2_video_ntF}
                                alt="new-ntf-image"
                              />
                              <p>You don't have any exercise for Practice</p>
                            </div>
                          )
                        ) : (
                          <div
                            className="no_data_found_wrapper"
                            style={{ textAlign: "center", margin: "auto" }}
                          >
                            <img
                              src={images.new_m2_video_ntF}
                              alt="new-ntf-image"
                            />
                            <p>There is no exercise yet!</p>
                          </div>
                        )
                      ) : (
                        <div
                          className="no_data_found_wrapper"
                          style={{ textAlign: "center", margin: "auto" }}
                        >
                          <img
                            src={images.new_m2_video_ntF}
                            alt="new-ntf-image"
                          />
                          <p>There is no exercise yet!</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade custom_tab_pane"
                  id="pills-previous-class"
                  role="tabpanel"
                  aria-labelledby="pills-previous-class-tab"
                >
                  <div className="sec_1_inner_wrapper">
                    <div
                      className="exercise_collection_wrapper"
                      style={{
                        overflowY: "visible",
                        padding: "0",
                      }}
                    >
                      {!isEmpty(state.exercisesData) ? (
                        state.exercisesData.ExerciseList.length ? (
                          resumePracticeExercises.length ? (
                            resumePracticeExercises.map((element, index) =>
                              renderPracticeDocCard({
                                cardKey: `resume-${index}`,
                                title: element.excersie_type,
                                questionCount: element.total_question,
                                durationMins: getPracticeDurationMins(element),
                                isResume: true,
                                onClick: () =>
                                  handleStoreDataInStorage("exercise", element),
                              })
                            )
                          ) : (
                            <div
                              className="no_data_found_wrapper"
                              style={{ textAlign: "center", margin: "auto" }}
                            >
                              <img
                                src={images.new_m2_video_ntF}
                                alt="new-ntf-image"
                              />
                              <p>You don't have any exercise to Resume</p>
                            </div>
                          )
                        ) : (
                          <div
                            className="no_data_found_wrapper"
                            style={{ textAlign: "center", margin: "auto" }}
                          >
                            <img
                              src={images.new_m2_video_ntF}
                              alt="new-ntf-image"
                            />
                            <p>There is no exercise yet!</p>
                          </div>
                        )
                      ) : (
                        <div
                          className="no_data_found_wrapper"
                          style={{ textAlign: "center", margin: "auto" }}
                        >
                          <img
                            src={images.new_m2_video_ntF}
                            alt="new-ntf-image"
                          />
                          <p>There is no exercise yet!</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderNotesCollectionView = () => {
    return (
      <Fragment>
        <div className="notesCollectionView_wrapper">
          <div
            className="notesCollectionView_inner_wrapper topic-notes-scroll"
            id="parentScrollDiv"
          >
            <InfiniteScroll
              dataLength={state?.notesData?.length}
              next={fetchNotesData}
              hasMore={true}
              scrollableTarget="parentScrollDiv"
            >
              <div className="notes_collection_wrapper">
                {!isEmpty(state.notesData) ? (
                  state.notesData.length ? (
                    state.notesData.map((element, index) => {
                      const pageCount =
                        element.total_pages ||
                        element.pages ||
                        element.page_count;
                      const fileSize =
                        element.file_size || element.notes_size || element.size;
                      const noteMeta = [
                        "PDF",
                        fileSize,
                        pageCount ? `${pageCount} Pages` : "",
                      ]
                        .filter(Boolean)
                        .join(" • ");

                      return (
                        <div
                          key={index}
                          className="topic-note-card"
                          onClick={() =>
                            handleStoreDataInStorage("notes", element)
                          }
                        >
                          <div className="topic-note-icon">
                            <img src={noteFileIcon} alt="" />
                          </div>
                          <div className="topic-note-copy">
                            <p className="topic-note-title">
                              {element.notes_title}
                            </p>
                            <p className="topic-note-meta">{noteMeta}</p>
                          </div>
                          <img
                            className="topic-note-chevron"
                            src={noteChevronIcon}
                            alt=""
                          />
                        </div>
                      );
                    })
                  ) : (
                    <div
                      className="no_data_found_wrapper"
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <img src={images.new_m2_video_ntF} alt="new-ntf-image" />
                      <p>There is no notes yet!</p>
                    </div>
                  )
                ) : (
                  <div
                    className="no_data_found_wrapper"
                    style={{ textAlign: "center", margin: "auto" }}
                  >
                    <img src={images.new_m2_video_ntF} alt="new-ntf-image" />
                    <p>There is no notes yet!</p>
                  </div>
                )}
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderDppCollectionView = () => {
    const exerciseListContext = {
      userId: userData?.user_id,
      courseId: courseDetails?.[0]?.course_id,
      topicId: topicData?.topicId,
    };

    return (
      <Fragment>
        <div
          className="dppCollectionView_wrapper"
          style={{ overflow: "visible", padding: "0" }}
        >
          <div className="dppCollectionView_inner_wrapper">
            <div className="sec_1_wrapper">
              <div className="dpp_collection_wrapper">
                {!isEmpty(state.dppCollections) ? (
                  state?.dppCollections?.DPPList?.length ? (
                    state.dppCollections.DPPList.map((element, index) =>
                      renderPracticeDocCard({
                        cardKey: `dpp-${index}`,
                        title: element.excersie_type,
                        questionCount: element.total_question,
                        durationMins: getPracticeDurationMins(element),
                        isResume: hasTopicPracticeProgress({
                          ...exerciseListContext,
                          exerciseType: element.excersie_type,
                        }),
                        onClick: () => handleStoreDataInStorage("dpp", element),
                      })
                    )
                  ) : (
                    <div
                      className="no_data_found_wrapper"
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <img src={images.new_m2_video_ntF} alt="new-ntf-image" />
                      <p>You don't have any Dpp for Practice</p>
                    </div>
                  )
                ) : (
                  <div
                    className="no_data_found_wrapper"
                    style={{ textAlign: "center", margin: "auto" }}
                  >
                    <img src={images.new_m2_video_ntF} alt="new-ntf-image" />
                    <p>You don't have any Dpp for Practice</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderPyqCollectionView = () => {
    return (
      <Fragment>
        <div className="pyqCollectionView_wrapper_topic">
          <div className="pyqCollectionView_inner_wrapper_topic">
            <div className="sec_1_wrapper">
              <div className="pyq_collection_wrapper_topic">
                {!isEmpty(props.pyqData) ? (
                  props.pyqData.length ? (
                    props.pyqData.map((element, index) =>
                      renderPracticeDocCard({
                        cardKey: `pyq-${index}`,
                        title: `${element.topic_name}(${
                          element.format ? element.format.toUpperCase() : ""
                        })`,
                        questionCount: element.total_questions,
                        durationMins: getPracticeDurationMins(element),
                        isResume: hasTopicPracticeProgress({
                          userId: userData?.user_id,
                          courseId: courseDetails?.[0]?.course_id,
                          topicId: topicData?.topicId,
                          exerciseType: getPyqProgressType(element),
                        }),
                        onClick: () => handleStoreDataInStorage("pyq", element),
                      })
                    )
                  ) : (
                    <div
                      className="no_data_found_wrapper"
                      style={{ textAlign: "center", margin: "auto" }}
                    >
                      <img src={images.new_m2_video_ntF} alt="new-ntf-image" />
                      <p>No PYQs available yet!</p>
                    </div>
                  )
                ) : (
                  <div
                    className="no_data_found_wrapper"
                    style={{ textAlign: "center", margin: "auto" }}
                  >
                    <img src={images.new_m2_video_ntF} alt="new-ntf-image" />
                    <p>No PYQs available yet!</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const handleChangeFeature = (event) => {
    let { value } = event.target;

    switch (value) {
      case "videos":
        persistTopicTab(1);
        setState((prevState) => ({
          ...prevState,
          featureType: 1,
          pageNumber: 1,
        }));
        setActiveFeatureType(1);
        break;
      case "live_class":
        persistTopicTab(2);
        setState((prevState) => ({
          ...prevState,
          featureType: 2,
          pageNumber: 1,
        }));
        setActiveFeatureType(2);
        break;
      case "exercise":
        persistTopicTab(3);
        setState((prevState) => ({
          ...prevState,
          featureType: 3,
          pageNumber: 1,
        }));
        setActiveFeatureType(3);
        break;
      case "notes":
        persistTopicTab(4);
        setState((prevState) => ({
          ...prevState,
          featureType: 4,
          pageNumber: 1,
        }));
        setActiveFeatureType(4);
        break;
      case "dpp":
        persistTopicTab(5);
        setState((prevState) => ({
          ...prevState,
          featureType: 5,
          pageNumber: 1,
        }));
        setActiveFeatureType(5);
        break;
      case "additional_videos":
        persistTopicTab(6);
        setState((prevState) => ({
          ...prevState,
          featureType: 6,
          pageNumber: 1,
        }));
        setActiveFeatureType(6);
        break;
      case "pyq":
        persistTopicTab(7);
        setState((prevState) => ({
          ...prevState,
          featureType: 7,
          pageNumber: 1,
        }));
        setActiveFeatureType(7);
        break;
      default:
        break;
    }
  };

  let page_limit = 10;

  const fetchVideosData = async () => {
    let pageNo = Math.ceil(state.videosData.length / page_limit) + 1;
    let data = {
      search: "",
      course_id: crsID,
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
      faculty_id: state?.currentFacultyName?.user_id,
      page: pageNo,
    };
    if (videosPagingRef.current || !videosHasMore) return;
    videosPagingRef.current = true;
    try {
      const response = await axios.get(
        `${url_11}?page=${data.page}&search=${data.search}&course_id=${data.course_id}&subject_id=${data.subject_id}&topic_id=${data.topic_id}&faculty_id=${data.faculty_id}`
      );
      if (response.data.status === 200) {
        const videoPage = response.data.data.VideoList.data || [];
        const unlockedVideos = videoPage.filter(
          (video) => video.is_locked !== 1
        );
        setVideosHasMore(videoPage.length >= page_limit);
        setState((prevState) => {
          const nextVideos = [...prevState.videosData, ...unlockedVideos];
          const facultyId = prevState.currentFacultyName?.user_id;
          if (facultyId != null) {
            facultyVideosCacheRef.current[facultyId] = {
              videos: nextVideos,
              hasMore: videoPage.length >= page_limit,
            };
          }
          return {
            ...prevState,
            videosData: nextVideos,
          };
        });
      } else {
        setVideosHasMore(false);
      }
    } catch (error) {
      console.log(error);
      setVideosHasMore(false);
    } finally {
      videosPagingRef.current = false;
    }
  };

  const fetchLiveRecordedData = async () => {
    let pageNo = Math.ceil(state.liveVideoData.length / page_limit) + 1;
    console.log("pageNo", pageNo);
    let data = {
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
      type: "live",
      page: pageNo,
    };
    if (livePagingRef.current || !liveHasMore) return;
    livePagingRef.current = true;
    try {
      const response = await axios.get(
        `${url_214}/?page=${data.page}&subject_id=${data.subject_id}&topic_id=${data.topic_id}&type=live`
      );
      if (response.status === 200) {
        const livePage = response.data.data || [];
        setLiveHasMore(livePage.length >= page_limit);
        setState((prevState) => ({
          ...prevState,
          liveVideoData: [...prevState.liveVideoData, ...livePage],
        }));
      } else {
        setLiveHasMore(false);
      }
    } catch (error) {
      console.log(error);
      setLiveHasMore(false);
    } finally {
      livePagingRef.current = false;
    }
  };

  const fetchNotesData = async () => {
    let pageNo = Math.ceil(state.notesData.length / 20) + 1;
    let data = {
      search: "",
      course_id: crsID,
      subject_id: subjectData?.subjectId,
      topic_id: topicData.topicId,
      pageNo: pageNo,
    };

    startLoading();
    try {
      const response = await axios.get(
        `${url_13}?page=${data.pageNo}&search=${data.search}&course_id=${data.course_id}&subject_id=${data.subject_id}&topic_id=${data.topic_id}`
      );

      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          notesData: [
            ...prevState.notesData,
            ...response.data.data.NotesList.data,
          ],
        }));
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const fetchData = () => {
    fetchVideosData();
  };

  const handleRedirect = () => {
    const courseId = resolveCourseId(location.state);
    history.push({
      pathname: "/dashboard/student-learning",
      state: {
        courseId,
        screenVersion: "new",
        returnTo: "/dashboard",
      },
    });
  };

  return (
    <Fragment>
      <div
        className={`topicContentComponent_wrapper${
          loader ? " topic-section-loading" : ""
        }`}
      >
        <div className="container">
          <div className="topicContentComponent_inner_wrapper">
            <div className="sec_1_wrapper">
              <div className="sec_1_inner_wrapper">
                <div className="btn_wrapper">
                  <button onClick={() => handleRedirect()} aria-label="Back">
                    <svg
                      className="topic-back-arrow"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        d="M19.5 12H6.5M12.5 5.5L5.5 12L12.5 18.5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <div className="text_content_wrapper">
                  <p className="text_content" style={{ marginTop: "0.1px" }}>
                    {topicData.topicName}
                  </p>
                </div>
              </div>
            </div>
            <div className="sec_2_wrapper">
              <div className="sec_2_inner_wrapper">
                <div className="content_wrapper">
                  <div className="left_side_content_wrapper">
                    <div className="feature_collection_wrapper">
                      {topicData.is_video_available ? (
                        <div className="single_select_feature topic-tab topic-tab-lectures">
                          <input
                            type="radio"
                            id="videos"
                            name="feature"
                            value="videos"
                            onChange={(event) => handleChangeFeature(event)}
                            checked={state.featureType === 1}
                          />
                          <label htmlFor="videos">Lectures</label>
                        </div>
                      ) : null}

                      {topicData.is_live_class_available ? (
                        <div className="single_select_feature topic-tab topic-tab-live">
                          <input
                            type="radio"
                            id="live_class"
                            name="feature"
                            value="live_class"
                            onChange={(event) => handleChangeFeature(event)}
                            checked={state.featureType === 2}
                          />
                          <label htmlFor="live_class">Live class</label>
                        </div>
                      ) : null}
                      {topicData.is_excersice_available ? (
                        <div className="single_select_feature topic-tab topic-tab-exercise">
                          <input
                            type="radio"
                            id="exercise"
                            name="feature"
                            value="exercise"
                            onChange={(event) => handleChangeFeature(event)}
                            checked={state.featureType === 3}
                          />
                          <label htmlFor="exercise">Exercises</label>
                        </div>
                      ) : null}

                      {topicData.is_dpp_available ? (
                        <div className="single_select_feature topic-tab topic-tab-dpp">
                          <input
                            type="radio"
                            id="dpp"
                            name="feature"
                            value="dpp"
                            onChange={(event) => handleChangeFeature(event)}
                            checked={state.featureType === 5}
                          />
                          <label htmlFor="dpp">DPP's</label>
                        </div>
                      ) : null}

                      {topicData.is_notes_available ? (
                        <div className="single_select_feature topic-tab topic-tab-notes">
                          <input
                            type="radio"
                            id="notes"
                            name="feature"
                            value="notes"
                            onChange={(event) => handleChangeFeature(event)}
                            checked={state.featureType === 4}
                          />
                          <label htmlFor="notes">Notes</label>
                        </div>
                      ) : null}

                      {topicData.is_additional_video_available ? (
                        <div className="single_select_feature topic-tab topic-tab-additional">
                          <input
                            type="radio"
                            id="additional_videos"
                            name="feature"
                            value="additional_videos"
                            onChange={(event) => handleChangeFeature(event)}
                            checked={state.featureType === 6}
                          />
                          <label htmlFor="additional_videos">
                            Additional Videos
                          </label>
                        </div>
                      ) : null}

                      {topicData.is_pyq_available ? (
                        <div className="single_select_feature topic-tab topic-tab-pyq">
                          <input
                            type="radio"
                            id="pyq"
                            name="feature"
                            value="pyq"
                            onChange={(event) => handleChangeFeature(event)}
                            checked={state.featureType === 7}
                          />
                          <label htmlFor="pyq">PYQ's</label>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="right_side_content_wrappers">
                    {renderFetaures()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userPreference: state.userPreference,
    subjectData: state.userActivity.subjectData,
    topicData: state.userActivity.topicData,
    token: state.auth.authToken,
    tokenType: state.auth.tokenType,
    activeFeatureType: state.userActivity.activeFeatureType,
    pyqData: state.userActivity.pyqData,
    userData: state.auth.user,
    loader: state.ui.loader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setFeature: (payload) => {
      dispatch(userActivityActions.setFeature(payload));
    },
    setVideoData: (payload) => {
      dispatch(userActivityActions.setVideoData(payload));
    },
    setRecordedVideoData: (payload) => {
      dispatch(userActivityActions.setRecordedVideoData(payload));
    },
    setNotesData: (payload) => {
      dispatch(userActivityActions.setNotesData(payload));
    },
    setLiveStreamData: (payload) => {
      dispatch(userActivityActions.setLiveStreamData(payload));
    },
    setExerciseData: (payload) => {
      dispatch(userActivityActions.setExerciseData(payload));
    },
    setLiveStreamVideoData: (payload) => {
      dispatch(userActivityActions.setLiveStreamVideoData(payload));
    },
    setLiveVideoStreamDetailsAction: (payload) => {
      dispatch(setLiveVideoStreamDetails(payload));
    },
    setWatchedVideoDetailsAction: (payload) => {
      dispatch(setWatchedVideoDetails(payload));
    },
    setNoteAddedVideoTimeAction: (payload) => {
      dispatch(setNoteAddedVideoTime(payload));
    },
    setPyqData: (payload) => {
      dispatch(userActivityActions.setPyqData(payload));
    },
    setActiveFeatureType: (payload) => {
      dispatch(userActivityActions.setActiveFeatureType(payload));
    },
    setPyqTestsData: (payload) => {
      dispatch(userPyqTestsAction.setPyqTestsData(payload));
    },
    setPyqTopicSubject: (payload) => {
      dispatch(userActivityActions.setPyqTopicSubject(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopicContentComponent);
